var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_108)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5 0C13.2075 0 0 13.2075 0 29.5C0 45.7924 13.2075 59 29.5 59C45.7924 59 59 45.7924 59 29.5C59 13.2075 45.7924 0 29.5 0ZM18.4466 49.4731H10.1534V22.79H18.4466V49.4731ZM14.3018 19.1426C11.6437 19.1426 9.49191 16.9878 9.49191 14.3332C9.49251 11.6811 11.6437 9.52631 14.3018 9.52631C16.9528 9.52631 19.1075 11.6811 19.1075 14.3332C19.1075 16.9884 16.9522 19.1426 14.3018 19.1426ZM49.5075 49.4731H41.2209V36.4967C41.2209 33.4021 41.1636 29.4221 36.9102 29.4221C32.597 29.4221 31.9336 32.7925 31.9336 36.2728V49.4725H23.6477V22.79H31.6017V26.4362H31.7133C32.8209 24.3382 35.5249 22.1267 39.5599 22.1267C47.9575 22.1267 49.5075 27.653 49.5075 34.8375V49.4731Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_108"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.e634fae34914e7bdc61cad96d2d1cc80.svg";
export { ForwardRef as ReactComponent };